<template>
    <div>
        <v-app class="p-4">
            <div class="col-md-12 p-0 mt-5 pt-10 mx-auto" style="border: none!important;">
                <v-tooltip right>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn text class="float-left" small @click="getDataForTable(url)" v-bind="attrs"
                               v-on="on"><span class="material-icons">refresh</span></v-btn>
                    </template>
                    <span>به روز رسانی لیست یادآوری ها</span>
                </v-tooltip>
                <!--      end edit mode -->
                <template>
                    <v-row justify="center">
                        <v-dialog
                                v-if="historyModal"
                                v-model="historyModal"
                                max-width="1200"
                                hide-overlay
                                transition="dialog-bottom-transition">
                            <v-card>
                                <v-toolbar
                                        flat
                                        dark
                                        color="primary"
                                >
                                    <v-toolbar-title>ایجاد تاریخچه</v-toolbar-title>
                                    <v-spacer></v-spacer>
                                    <v-toolbar-items>
                                        <v-btn
                                                icon
                                                dark
                                                @click="historyModal = false"
                                        >
                                            <v-icon>mdi-close</v-icon>
                                        </v-btn>
                                    </v-toolbar-items>
                                </v-toolbar>
                                <list-history :estate="type_id" :id="related_id"></list-history>
                            </v-card>
                        </v-dialog>
                        <v-dialog
                                v-if="showMore"
                                v-model="showMore"
                                max-width="1200"
                                hide-overlay
                                transition="dialog-bottom-transition"
                        >
                            <v-card>
                                <v-toolbar
                                        flat
                                        dark
                                        color="primary"
                                >

                                    <v-toolbar-title>اطلاعات بیشتر آگهی</v-toolbar-title>
                                    <v-spacer></v-spacer>
                                    <v-toolbar-items>
                                        <v-btn
                                                icon
                                                dark
                                                @click="showMore = false"
                                        >
                                            <v-icon>mdi-close</v-icon>
                                        </v-btn>
                                    </v-toolbar-items>
                                </v-toolbar>
                                <more-information :information="related_id"></more-information>
                            </v-card>
                        </v-dialog>
                    </v-row>
                </template>

                <template>
                    <v-row justify="center">
                        <v-dialog
                                v-if="showDescrption"
                                v-model="showDescrption"
                                max-width="600"
                                hide-overlay
                                transition="dialog-bottom-transition">
                            <v-card>
                                <v-toolbar
                                        flat
                                        dark
                                        color="primary"
                                >
                                    <v-toolbar-title>توضیحات</v-toolbar-title>
                                    <v-spacer></v-spacer>
                                    <v-toolbar-items>
                                        <v-btn
                                                icon
                                                dark
                                                @click="showDescrption = false"
                                        >
                                            <v-icon>mdi-close</v-icon>
                                        </v-btn>
                                    </v-toolbar-items>
                                </v-toolbar>
                                <div class="p-10">
                                    <p>مذاکرات انجام شده :</p>
                                    <p v-html="myDesc"></p>
                                    <hr>
                                    <p>موارد پیگیری در تماس بعدی :</p>
                                    <p v-html="myPurpose"></p>
                                </div>
                            </v-card>
                        </v-dialog>
                        <v-dialog
                                v-model="showMore"
                                max-width="1200"
                                hide-overlay
                                transition="dialog-bottom-transition"
                        >
                            <v-card>
                                <v-toolbar
                                        flat
                                        dark
                                        color="primary"
                                >

                                    <v-toolbar-title>اطلاعات بیشتر آگهی</v-toolbar-title>
                                    <v-spacer></v-spacer>
                                    <v-toolbar-items>
                                        <v-btn
                                                icon
                                                dark
                                                @click="showMore = false"
                                        >
                                            <v-icon>mdi-close</v-icon>
                                        </v-btn>
                                    </v-toolbar-items>
                                </v-toolbar>
                                <more-information v-if="showMore"
                                                  :information="related_id"></more-information>
                            </v-card>
                        </v-dialog>
                    </v-row>
                </template>

                <v-tabs v-model="tab" color="deep-purple accent-4" class="mt-5" grow>
                    <v-tab v-for="item in TabsName" :key="item.value">{{ item.name }}</v-tab>
                </v-tabs>
                <v-tabs-items v-model="tab">
                    <v-tab-item>
                        <v-card v-if="tab==0" :loading="loading" class="p-3 pt-0 mt-10">
                            <v-simple-table>
                                <template v-slot:default>
                                    <thead>
                                    <tr>
                                        <th class="text-center" v-for="item in titles">
                                            {{ item }}
                                        </th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr
                                            v-for="(item,index) in datas.filter((x) => x.type === 'estate')"
                                            :key="item.id"
                                            class="text-center"
                                    >
                                        <td>{{ index + 1 }}</td>
                                        <td>{{ item.title }}</td>
                                        <td>{{ setTimes(item.remind_date_p, 1) }}</td>
                                        <td>{{ setTimes(item.remind_date_p, 0) }}</td>
                                        <td>{{ item.type }}</td>
                                        <td>{{ item.user.name + ' ' + item.user.lastName }}</td>
                                        <td>
                                            <v-btn title="دیده شد" @click="seen(item.id,item.type)" icon
                                                   class="submit-btn"><span
                                                    class="fa fa-eye"></span></v-btn>
                                            <v-btn title="تاریخچه" @click="history(item.type,item.reference)" icon
                                                   class="btn-update"><span
                                                    class="fa fa-history"></span></v-btn>
                                            <v-btn title="مشاهده توضیحات" @click="showDes(item.description,item.purpose)" icon
                                                   class="btn-upload"><span
                                                    class="fa fa-list"></span></v-btn>
                                        </td>
                                    </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </v-card>
                    </v-tab-item>
                    <v-tab-item>
                        <v-card v-if="tab==1" :loading="loading" class="p-3 pt-0 mt-10">
                            <v-simple-table>
                                <template v-slot:default>
                                    <thead>
                                    <tr>
                                        <th class="text-center" v-for="item in titles">
                                            {{ item }}
                                        </th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr
                                            v-for="(item,index) in datas.filter((x) => x.type === 'customer')"
                                            :key="item.id"
                                            class="text-center"
                                    >
                                        <td>{{ index + 1 }}</td>
                                        <td>{{ item.title }}</td>
                                        <td>{{ setTimes(item.remind_date_p, 1) }}</td>
                                        <td>{{ setTimes(item.remind_date_p, 0) }}</td>
                                        <td>{{ item.type }}</td>
                                        <td>{{ item.user.name + ' ' + item.user.lastName }}</td>
                                        <td>
                                            <v-btn title="دیده شد" @click="seen(item.id,item.type)" icon
                                                   class="submit-btn"><span
                                                    class="fa fa-eye"></span></v-btn>
                                            <v-btn title="تاریخچه" @click="history(item.type,item.reference)" icon
                                                   class="btn-update"><span
                                                    class="fa fa-history"></span></v-btn>
                                            <v-btn title="مشاهده توضیحات" @click="showDes(item.description,item.purpose)" icon
                                                   class="btn-upload"><span
                                                    class="fa fa-list"></span></v-btn>
                                        </td>
                                    </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </v-card>
                    </v-tab-item>
                </v-tabs-items>
            </div>
        </v-app>
    </div>
</template>
<script>
import {debounce} from "../../../../custom";
import {Axios2} from "../../../../main";
import ListHistory from "../states/history/listHistory";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

export default {
    name: "remindersList",
    components: {ListHistory},
    data() {
        return {
            authModal: false,
            historyModal: false,
            loading: false,
            type_id: 'false',
            editor: ClassicEditor,
            editorConfig: {
                language: 'fa'
            },
            TabsName: [
                {name: 'یادآوری فایل ها', value: 'newCustomer'},
                {name: 'یادآوری مشتریان ', value: 'list'}
            ],
            tab: "",
            types: [{name: 'املاک', value: 'estate'}, {name: 'مشتری', value: 'customer'}],
            related_id: null,
            datas: {},
            titles: ["ردیف", "عنوان", "زمان یادآوری", "تاریخ یادآوری", "منتشر کننده", "ثبت کننده", 'مدیریت'],
            mine: [],
            myRes: [],
            activeComponent: '',
            url: `${url}/user/reminder`,
            selectedNumber: [],
            translates: [],
            dataId: '',
            adsList: '',
            nowTime: '',
            myDesc: '',
            myPurpose: '',
            showDescrption: false,
            updatedData: [],
            authResult: [],
        }
    },
    methods: {
        getDataForTable(url = this.url, query = this.tableProps) {
            const vm = this;

            vm.datas = [];
            vm.loading = true;

            $.ajax({
                url: url,
                type: 'GET',
                fn: this.getDataForTable,
                data: Object.assign({}, query, {agent: this.officers_id != null && this.officers_id !== 'فایل های شخصی' ? this.officers_id : undefined}),
                headers: {
                    "ACCEPT": "application/json",
                    "Authorization": Token
                },
                success: function (data) {
                    vm.datas = data.data;
                    vm.loading = false;
                }
            })
        },
        reloadTable(tableProps) {
            debounce(() => {
                this.getDataForTable(this.url, tableProps);
            }, 700);
        },
        seen(id, type) {
            this.$modal.showLoading();
            Axios2.put('user/reminder/seen', JSON.stringify({
                "reference": id,
                "type": type
            })).then((x) => {
                this.$modal.hideLoading();
                this.$modal.success('موفقیت آمیز!');
                this.reloadTable(this.url);
            })
        },
        history(id, value) {
            this.historyModal = true
            if (id === 'estate') {
                this.type_id = true
            } else
                this.type_id = false;

            this.related_id = value
        },
        setTimes(value, index = 0) {
            const a = value.split(" ");
            return a[index];
        },
        showDes(value,purpose) {
            this.showDescrption = true;
            this.myDesc = value;
            this.myPurpose = purpose;

        }
    },
    mounted() {
        this.getDataForTable(this.url);
        $(document).on('click', '#selectAll', (element) => {
            if ($(element.target).is(':checked')) {
                $('input[type="checkbox"]').prop('checked', true);

                const selected = $('input[type="checkbox"]').map(function () {
                    return $(this).data('id')
                }).get();

                this.selectedNumber = selected;
            } else {
                $('input[type="checkbox"]').prop('checked', false)
                this.selectedNumber = []
            }
        });
    },
}
</script>

<style scoped>

</style>